import { useAuthStore } from "auth/AuthStore";
import { observer } from "mobx-react-lite";
import { useParams } from "react-router-dom";
import useStore from "reusable/mobx-store-utils";
import MainContainer from "./main-container/MainContainer";
import OrgGuardStore, { OrgGuardStoreProvider } from "./OrgGuardStore";
import { useRegionRouterStore } from "features/main/RegionRouterStore";
import GuestContainer from "./guest-container/GuestContainer";
import { useEffect } from "react";
import { PlatformContainer } from "reusable/containers/PlatformContainer";
import useInitialMount from "reusable/hooks/useInitialMount";
import CacheProvider from "cache/CacheProvider";
import { useThemeStore } from "theme/ThemeStore";
import variables from "variables/variables";

export default observer(
   function OrgGuard() {
      const authStore = useAuthStore()
      const { orgId } = useParams()
      const regionRouterStore = useRegionRouterStore()
      const themeStore = useThemeStore()
      const orgGuardStore = useStore(sp => new OrgGuardStore(sp), { themeStore, orgId, regionRouterStore, authStore })

      useInitialMount(() => {
         orgGuardStore.fetch()
      })

      useEffect(() => {
         orgGuardStore.setOrgPropertiesForSentryAndMixpanel()
      }, [orgId, orgGuardStore, orgGuardStore.org])

      // Wait for org to have been set in the cache
      if (orgGuardStore.loading) {
         const loadingMessage = (() => {
            if (orgGuardStore.loader.isLoading) {
               return orgGuardStore.loader.loaderText || "Loading organisation"
            } else if (orgGuardStore.networkError) {
               return `Unable to load user${variables.stage.startsWith('dev-') ? '. Ensure the server is running' : ''}`
            } else {
               return 'No user org data found'
            }
         })()
         return <PlatformContainer loadingMessage={loadingMessage} loading={true} contentCentered={true} />
      }

      return <OrgGuardStoreProvider store={orgGuardStore}>
         <CacheProvider>
            {/* For user with a Guest role */}
            {authStore.isGuest && <GuestContainer />}
            {/* For user without a Guest role */}
            {!authStore.isGuest && <MainContainer />}
         </CacheProvider>
      </OrgGuardStoreProvider>
   }
)
